import { FormattedMessage } from "react-intl";
import IconLock from "app/pages/.shared/IconLock";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";
import List from "app/pages/.shared/List";
import IconInfo from "app/pages/.shared/static/icons/IconInfo";
import PropTypes from "prop-types";
import { memo } from "react";

import "./PaymentSecurityNote.scss";

const PaymentSecurityNote = ({ brandDisplayName }) => {
	return (
		<div className="payment-security-note">
			<IconLock height={24} width={24} />
			<FormattedMessage id="payment.security.full" />

			<FloatingButton
				position="bottom"
				floatingContent={
					<List
						className="payment-security-note__list"
						items={[
							<FormattedMessage
								id="payment.security.note.1"
								key="payment.security.note.1"
							/>,
							<FormattedMessage
								id="payment.security.note.2"
								key="payment.security.note.2"
							/>,
							<FormattedMessage
								id="payment.security.note.3"
								key="payment.security.note.3"
								values={{
									brandName: brandDisplayName,
								}}
							/>,
						]}
					/>
				}
				referenceComponent={
					<IconInfo
						width={15}
						height={15}
						style={{ marginLeft: "5px" }}
						data-testid="payment-security-note-icon"
					/>
				}
			/>
		</div>
	);
};

PaymentSecurityNote.propTypes = {
	brandDisplayName: PropTypes.string,
};
export default memo(PaymentSecurityNote);
